export default {
  additional_questions: 'elite',
  default_gender: 'female',
  tags: ['מזכירות', 'משרה_חלקית', 'משרה_מלאה', 'הנה"ח', 'ניהול_משרד', 'בכיר/ה', 'רו"ח', 'אנליסט', 'שיווק', 'בק_אופיס', 'מזכירות_ערב', 'משמרות', 'סטודנט/ית', 'ניסיון_ממשרד_עו"ד', 'פראליגל', 'גבייה', 'אנגלית_שפת_אם', 'קבלה', 'חשבשבת', 'נט_המשפט', 'אקסל'],
  is_job_title_mandatory: true
}
